import { formatMoney } from "../../toll/money";
import { observer } from "mobx-react-lite";
import userStore from "../../stores/userStore";
import moment from "moment";
import PageBox from "../../layout/PageBox";
import { useEffect } from "react";
import { campaignStore } from "../../stores";
import { afd_create_campaign_icon, member_icon } from "../../imgs";
import { MyColor } from "../../config/myStyle";
import { MdKeyboardArrowDown } from "react-icons/md";
import MyRecordCampaignItem from "./MyRecordCampaignItem";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MyRecord = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const userId = userStore.userData?.id;
  // 先刷新本人累計；取得帳號後才查活動，避免短暫展示其他人的活動。
  useEffect(() => { userStore.getUser(); }, []);
  useEffect(() => {
    if (userId) campaignStore.getCampaignList({ limit: 2, userId });
  }, [userId]);

  const userData = userStore.userData

  const onAll = () => {
    campaignStore.loadMoreCampaign({ limit: 1000, userId: userStore.userData?.id })
  }

  return (
    <PageBox spinning={campaignStore.campaignListStatus.loading || campaignStore.loadMoreStatus.loading}>
      <div>
        <div className="flex flex-col items-coneter px-[18px]" style={{ color: MyColor.blue, fontWeight: 500, fontSize: 16 }}>
          {/* 用户信息 */}
          <div className="mt-[12px] flex items-center rounded-t-[18px] bg-[white] px-[18px] py-[14px]" style={{ borderBottomWidth: 4, borderColor: MyColor.sub }}>
            <img className="h-[54px]" src={member_icon} alt="" />
            <div className="ml-[18px]">
              <div
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {[userData?.englishGivenName, userData?.englishSurname].filter(Boolean).join(' ')}
              </div>
              <div
                className="mt-[4px]"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: "vertical"
                }}
              >
                {t('my_record.account_no')}{userData?.memberNumber??userData?.id}
              </div>
            </div>
          </div>
          {/* 标题 */}
          <div className="mt-[24px] font-[700] text-[20px]" style={{ textAlign: 'center' }}>{t('my_record.your_current_campaign')}</div>
          {/* campaign items */}
          {campaignStore.campaignList.length ? (
            <div className="flex-col flex space-y-[12px]">
              {campaignStore.campaignList.map((item, index) => (
                <MyRecordCampaignItem
                  key={item.id}
                  campaign={item}
                />
              ))}
            </div>
          ) : (
            <div className="mt-[16px] flex justify-center">
              <button
                className="flex min-h-[164px] w-[172px] flex-col items-center justify-center rounded-[24px] border-[5px] border-[#C8A16C] bg-[white] px-[12px] py-[16px] text-center"
                onClick={() => navigate("/campaign/create")}
              >
                <img src={afd_create_campaign_icon} alt="" className="h-[82px] w-[82px]" />
                <div className="mt-[10px] text-[18px] font-[700] leading-[1.22]" style={{ color: MyColor.blue }}>
                  {t("my_record.create_campaign")}
                </div>
              </button>
            </div>
          )}

          {campaignStore.hasMore ? (
            <div className="mb-[10px] mt-[8px] flex flex-1 items-center justify-center space-x-[5px]" onClick={onAll}>
              <MdKeyboardArrowDown className="text-[30px]" style={{ color: MyColor.sub }} />
              <div className="fonst-[500] text-[15px]">{t('my_record.view_all')}</div>
            </div>
          ) :
            <div className=" mt-[20px]" />
          }
        </div>
        {/* total raised */}
        <div className="mt-[14px] h-[1.5px] bg-[rgba(0,0,0,0.28)]" />
        <div className="mt-[14px] flex flex-col items-center justify-center font-[700] text-[20px]" style={{ color: MyColor.blue, lineHeight: 1.4 }}>
          <div>{t('my_record.total_raised')}</div>
          <div className="text-[14px]">{t('my_record.hkd')}</div>
          <div className="text-[34px]" style={{ lineHeight: 1.2 }}>{formatMoney(userData?.receivedDonationAmount)}</div>
          {userData?.receivedDonationAt && (
            <div className="text-[14px] font-[400]">
              {t('my_record.balance_as_at')} {moment(userData?.receivedDonationAt).format("D MMM, YYYY")}
            </div>
          )}
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: 140,
              alignSelf: 'center',
              justifySelf: 'center',
              borderRadius: 20,
              background: MyColor.sub,
              height: 44,
              fontSize: 22,
              color: "white",
              fontWeight: 500,
              marginTop: 10,
              marginBottom: 30,
            }}
            onClick={() => navigate('/my-record/total-raised')}
          >
            {t('my_record.detail')}
          </Button>
        </div>

        {/* donation amount */}
        <div className="h-[1.5px] bg-[rgba(0,0,0,0.28)]" />
        <div className="mt-[14px] flex flex-col items-center justify-center font-[700] text-[20px]" style={{ color: MyColor.blue, lineHeight: 1.4 }}>
          <div>{t('my_record.donation_amount')}</div>
          <div className="text-[14px]">{t('my_record.hkd')}</div>
          <div className="text-[34px]" style={{ lineHeight: 1.2 }}>{formatMoney(userData?.donatedAmount)}</div>
          {userData?.donatedAt && (
            <div className="text-[14px] font-[400]">
              {t('my_record.balance_as_at')} {moment(userData?.donatedAt).format("D MMM, YYYY")}
            </div>
          )}
          <Button
            type="primary"
            htmlType="submit"
            style={{
              width: 140,
              alignSelf: 'center',
              justifySelf: 'center',
              borderRadius: 20,
              background: MyColor.sub,
              height: 44,
              fontSize: 22,
              color: "white",
              fontWeight: 500,
              marginTop: 10,
              marginBottom: 30,
            }}
            onClick={() => navigate('/my-record/donation-amount')}
          >
            {t('my_record.detail')}
          </Button>
        </div>
      </div>
    </PageBox >
  );
})

export default MyRecord;
